// @ts-nocheck
export default {
  es: {
    RESOURCE_CARD_TITLE: '#LogrosCrehana ¡Porque tu esfuerzo merece un premio!',
    RESOURCE_CARD_DESCRIPTION:
      'Cursos gratis para que tu educación no se detenga y aproveches al máximo tu tiempo',
    RESOURCE_CARD_DAY: 'Hace {{count}} día',
    RESOURCE_CARD_DAY_plural: 'Hace {{count}} días',
    RESOURCE_CARD_HOUR: 'Hace {{count}} hora',
    RESOURCE_CARD_HOUR_plural: 'Hace {{count}} horas',
    RESOURCE_CARD_MINUTE: 'Hace {{count}} minuto',
    RESOURCE_CARD_MINUTE_plural: 'Hace {{count}} minutos',
    RESOURCE_CARD_SECOND: 'Hace {{count}} segundo',
    RESOURCE_CARD_SECOND_plural: 'Hace {{count}} segundos',

    BANNER_TITLE: 'Curso gratis del día',
    BANNER_CONTENT:
      'En estas {{totalLessons}} clases aprende lo esencial y lo importante para empezar tu camino para ser el mejor',
    BANNER_CTA: 'Míralo ahora',

    COLLAPSE_BAR_1: 'Al inscribirte al curso del día participas por una',
    COLLAPSE_BAR_2: 'Membresía Premium Anual',

    COURSE_AGENDA_ERROR: 'Ocurrió un error',
    COURSE_AGENDA_TITLE: 'Mira nuestra agenda de cursos gratis',
    COURSE_AGENDA_ENROLL: 'Inscribirme',
    COURSE_AGENDA_ALREADY_ENROLLED: 'Ya estás inscrito',

    COURSE_FREE_SIGNUP_TITLE: '¡Accede gratis a este curso por un día!',
    COURSE_FREE_SIGNUP_DIALOG_TITLE: 'Únete a Crehana',
    COURSE_FREE_SIGNUP_DIALOG_SUBTITLE: '¡Y accede al curso gratuito!',
    COURSE_FREE_SIGNUP_WITH: 'Regístrate con',
    COURSE_FREE_SIGNUP_CUSTOM_TITLE: 'Regístrate gratis',
    COURSE_FREE_SIGNUP_HAVE_ACCOUNT: '¿Tienes una cuenta?',
    COURSE_FREE_SIGNUP_LOGIN: 'Inicia Sesión',

    COURSE_FREE_TITLE: 'Curso gratis del día',
    COURSE_FREE_SEE_MORE: 'Ver más cursos',
    COURSE_FREE_STAT_STUDENTS: '{{count}} Alumnos',
    COURSE_FREE_STAT_COURSE_LEVEL: 'Curso {{level}}',

    ENROLLMENT_DIALOG_TITLE: '¡Gracias por inscribirte!',
    ENROLLMENT_DIALOG_DESCRIPTION:
      'Te enviaremos un correo cuando el curso esté gratis.',
    ENROLLMENT_DIALOG_CLOSE: 'Entendido',

    FEATURES_TITLE_1: 'Un curso gratis al día',
    FEATURES_DESCRIPTION_1: 'disponible por 24 horas.',
    FEATURES_TITLE_2: 'Subida de proyectos',
    FEATURES_DESCRIPTION_2: 'habilitada por 24 horas.',
    FEATURES_TITLE_3: 'Constancia de participación',
    FEATURES_DESCRIPTION_3: 'por tus horas de esfuerzo.',

    LIVE_BANNER_TITLE: 'Crehana Live: Conoce nuestras próximas clases en vivo',
    LIVE_BANNER_CTA: 'Ingresar a los lives',

    REGISTER_BAR_TITLE: 'Únete a Crehana',
    REGISTER_BAR_EMAIL: 'Correo electrónico',
    REGISTER_BAR_EMAIL_ERROR: 'Ingresa una dirección de correo válida',
    REGISTER_BAR_PASSWORD: 'Contraseña',
    REGISTER_BAR_REQUIRED_FIELD: 'Campo requerido',
    REGISTER_BAR_SUBMIT: 'Regístrate',

    CARD_LEAD_TITLE: 'Aprende sin límites',
    CARD_LEAD_COPY:
      'Estás a una llamada de acceder al mejor descuento en 800 cursos, mentorías, especializaciones y más.',
    CARD_LEAD_CTA: 'Conversemos',

    EXIT_POPUP_TITLE: '¡Espera! Tienes una prueba gratuita disponible',
    EXIT_POPUP_SUB_TITLE:
      'Descubre nuestra membresía con acceso a todos los cursos por 24 horas.',
    EXIT_POPUP_CTA: 'Pruébalo ahora',
  },
};
